import React, { Component, useEffect, useMemo, useRef } from "react";
import { injectIntl } from "react-intl";
import { Row, Card, CardBody, CardFooter, Badge, Input, Button } from "reactstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import axios from "axios";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import {
  AddCommaPhoneNumber,
  DEFAULT_COVER,
  getAvatar,
  getCompanyImage,
  getQrPay,
  NotificatioErrController,
  NotificatioSucController,
} from "../../../helpers/Utils";
import createSocket from "../../../helpers/createSocket";
import LogsHelper from "../../../helpers/Logs";
import CustomTooltip from "../../../components/CustomTooltip";
import SingleLightbox from "../../../components/pages/SingleLightbox";
import { isC, isF, isU } from "../../../helpers/Roles";
import { Update } from "../../../containers/pages/general";
import ContentFormPersonal from "../../../containers/applications/ContentFormPersonal";
import ContentFormCompany from "../../../containers/applications/ContentFormCompany";
import { GetBank, SetBank } from "../../../helpers/ListBank";
import Select from "react-select";
import CustomSelectInput from "../../../components/common/CustomSelectInput";
import QRCodeStyling from "qr-code-styling";
import { buildPublicMenuUrl } from "../../../helpers/PublicMenuUrl";

const ROLE_ALIAS = "profile";
const isFileObject = (file) => typeof File !== "undefined" && file instanceof File;

const copyToClipboard = (value) => {
  let input = document.createElement("input");
  input.setAttribute("value", value);
  document.body.appendChild(input);
  input.select();
  input.setSelectionRange(0, 99999); /*For mobile devices*/
  document.execCommand("copy");
  document.body.removeChild(input);

  NotificatioSucController("Thành công");
};

const MENU_QR_POSTER_CONFIG = {
  width: 900,
  height: 1580,
  outerMargin: 22,
  innerMargin: 46,
  borderRadius: 52,
  borderColor: "#e0362e",
  panelColor: "#efefef",
  titleColor: "#5b5b5b",
  bodyTextColor: "#5a5a5a",
  subTextColor: "#6d6d6d",
  qrSize: 570,
};

const drawRoundedRect = (ctx, x, y, width, height, radius) => {
  const r = Math.min(radius, width / 2, height / 2);

  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + width, y, x + width, y + height, r);
  ctx.arcTo(x + width, y + height, x, y + height, r);
  ctx.arcTo(x, y + height, x, y, r);
  ctx.arcTo(x, y, x + width, y, r);
  ctx.closePath();
};

const splitTextByWidth = (ctx, text, maxWidth, maxLines = 2) => {
  const normalized = String(text || "").trim();
  if (!normalized) return [];

  const words = normalized.split(/\s+/);
  let lines = [];
  let currentLine = words[0] || "";

  for (let i = 1; i < words.length; i += 1) {
    const nextLine = `${currentLine} ${words[i]}`;
    if (ctx.measureText(nextLine).width <= maxWidth) {
      currentLine = nextLine;
    } else {
      lines.push(currentLine);
      currentLine = words[i];
    }
  }

  lines.push(currentLine);

  if (lines.length <= maxLines) {
    return lines;
  }

  const fixedLines = lines.slice(0, maxLines - 1);
  let lastLine = lines.slice(maxLines - 1).join(" ");

  while (lastLine.length > 0) {
    const textWithEllipsis = `${lastLine}...`;
    if (ctx.measureText(textWithEllipsis).width <= maxWidth) {
      fixedLines.push(textWithEllipsis);
      return fixedLines;
    }
    lastLine = lastLine.slice(0, -1).trim();
  }

  fixedLines.push("...");
  return fixedLines;
};

const loadImageFromBlob = (blob) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (error) => {
      URL.revokeObjectURL(url);
      reject(error);
    };
    img.src = url;
  });

const canvasToBlob = (canvas) =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Không thể tạo ảnh từ canvas."));
          return;
        }
        resolve(blob);
      },
      "image/png",
      1,
    );
  });

const triggerDownload = (blob, filename) => {
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.download = filename;
  const supportsDownload = typeof link.download === "string";

  if (supportsDownload) {
    document.body.appendChild(link);
    link.click();
    link.remove();
  } else {
    window.open(url, "_blank");
  }

  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
};

const MenuOnlineQrCard = ({
  menuUrl,
  companyName,
  companyAddress,
  hotline,
  previewWidth = 125,
}) => {
  const qrRef = useRef(null);
  const qrCode = useMemo(() => {
    if (!menuUrl) return null;

    return new QRCodeStyling({
      data: menuUrl,
      width: 250,
      height: 250,
      image: "",
      qrOptions: {
        typeNumber: "8",
        mode: "Byte",
        errorCorrectionLevel: "Q",
      },
      dotsOptions: {
        color: "#f00",
        type: "dots",
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 20,
      },
      backgroundOptions: {
        color: "rgba(0,0,0,0)",
      },
      cornersSquareOptions: {
        type: "",
        color: "#ff0000",
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [
            { offset: 0, color: "#ff2424" },
            { offset: 1, color: "#9b0303" },
          ],
        },
      },
    });
  }, [menuUrl]);

  useEffect(() => {
    const wrapper = qrRef.current;
    if (!wrapper) return undefined;

    wrapper.innerHTML = "";
    if (qrCode) {
      qrCode.append(wrapper);
    }

    return () => {
      wrapper.innerHTML = "";
    };
  }, [qrCode]);

  const onDownloadClick = async (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!qrCode) return;

    try {
      const qrRawData = await qrCode.getRawData("png");
      const qrImage = await loadImageFromBlob(qrRawData);

      const {
        width,
        height,
        outerMargin,
        innerMargin,
        borderRadius,
        borderColor,
        panelColor,
        titleColor,
        bodyTextColor,
        subTextColor,
        qrSize,
      } = MENU_QR_POSTER_CONFIG;

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        throw new Error("Không khởi tạo được canvas để tạo poster QR.");
      }

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, width, height);

      drawRoundedRect(
        ctx,
        outerMargin,
        outerMargin,
        width - outerMargin * 2,
        height - outerMargin * 2,
        borderRadius,
      );
      ctx.fillStyle = borderColor;
      ctx.fill();

      drawRoundedRect(
        ctx,
        innerMargin,
        innerMargin,
        width - innerMargin * 2,
        height - innerMargin * 2,
        borderRadius - 14,
      );
      ctx.fillStyle = panelColor;
      ctx.fill();

      ctx.textAlign = "center";
      ctx.fillStyle = titleColor;
      ctx.font = "600 66px 'Nunito', 'Segoe UI', sans-serif";
      ctx.fillText("Quét mã QR", width / 2, 210);
      ctx.font = "500 58px 'Nunito', 'Segoe UI', sans-serif";
      ctx.fillText("để xem menu | gọi món", width / 2, 290);

      const qrX = (width - qrSize) / 2;
      const qrY = 360;
      ctx.fillStyle = panelColor;
      ctx.fillRect(qrX - 16, qrY - 16, qrSize + 32, qrSize + 32);
      ctx.drawImage(qrImage, qrX, qrY, qrSize, qrSize);

      const infoMaxWidth = width - 170;
      const storeInfoTopY = qrY + qrSize + 78;

      ctx.fillStyle = titleColor;
      ctx.font = "700 42px 'Nunito', 'Segoe UI', sans-serif";
      ctx.fillText(companyName || "VMASS", width / 2, storeInfoTopY, infoMaxWidth);

      ctx.fillStyle = bodyTextColor;
      ctx.font = "500 31px 'Nunito', 'Segoe UI', sans-serif";
      const addressLines = splitTextByWidth(
        ctx,
        companyAddress || "Đang cập nhật địa chỉ",
        infoMaxWidth,
        2,
      );
      const addressStartY = storeInfoTopY + 52;
      addressLines.forEach((line, lineIndex) => {
        ctx.fillText(line, width / 2, addressStartY + lineIndex * 40);
      });

      const phoneY = addressStartY + addressLines.length * 40 + 44;
      ctx.fillStyle = bodyTextColor;
      ctx.font = "600 32px 'Nunito', 'Segoe UI', sans-serif";
      ctx.fillText(
        `SĐT: ${hotline || "Đang cập nhật số điện thoại"}`,
        width / 2,
        phoneY,
        infoMaxWidth,
      );

      const dividerY = phoneY + 80;
      const badgeWidth = 280;
      const badgeHeight = 116;
      const badgeRadius = 28;
      const badgeX = width / 2 - badgeWidth / 2;
      const badgeY = dividerY - badgeHeight / 2;

      ctx.strokeStyle = "#888888";
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.moveTo(140, dividerY);
      ctx.lineTo(badgeX - 18, dividerY);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(badgeX + badgeWidth + 18, dividerY);
      ctx.lineTo(width - 140, dividerY);
      ctx.stroke();

      ctx.fillStyle = borderColor;
      drawRoundedRect(
        ctx,
        badgeX,
        badgeY,
        badgeWidth,
        badgeHeight,
        badgeRadius,
      );
      ctx.fill();

      ctx.fillStyle = "#ffffff";
      ctx.font = "700 40px 'Nunito', 'Segoe UI', sans-serif";
      ctx.textBaseline = "middle";
      ctx.fillText("Menu Online", width / 2, dividerY + 4);
      ctx.textBaseline = "alphabetic";

      ctx.fillStyle = bodyTextColor;
      ctx.font = "500 36px 'Nunito', 'Segoe UI', sans-serif";
      ctx.fillText("Mở Camera hoặc Zalo để quét mã", width / 2, 1450);
      ctx.fillStyle = subTextColor;
      ctx.font = "500 34px 'Nunito', 'Segoe UI', sans-serif";
      ctx.fillText("Bản quyền thuộc vmass.vn", width / 2, 1502);

      const posterBlob = await canvasToBlob(canvas);
      triggerDownload(posterBlob, "menu-online-poster.png");
    } catch (error) {
      console.error(error);
      qrCode.download({
        name: "menu-online",
        extension: "png",
      });
      NotificatioErrController(
        "Không thể tạo poster QR theo mẫu, đã tải file QR cơ bản.",
      );
    }
  };

  if (!menuUrl) return null;

  return (
    <Card className="mb-0" style={{ width: `${previewWidth + 28}px` }}>
      <div
        className="qrcode-wrapper mt-3 mb-2"
        style={{ width: `${previewWidth}px` }}
        ref={qrRef}
      />
      <CardFooter className="py-1 px-2 d-flex justify-content-between align-items-center position-relative">
        <span className="text-small">Menu Online</span>
        <div>
          <span
            className="cursor-pointer"
            onClick={onDownloadClick}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                onDownloadClick(event);
              }
            }}
          >
            <i className="simple-icon-cloud-download" />
          </span>
        </div>
      </CardFooter>
    </Card>
  );
};

const DEFAULT_FORM_PERSONAL = {
  id: "",
  fullname: "",
  email: "",
  birthDay: new Date(),
  avatar: "",
  avatarImageFile: "",
  phone: "",
  description: "",
  address: "",

  dynamic_form: [],
};

const DEFAULT_FORM_COMPANY = {
  id: "",
  companyName: "",
  companyAddress: "",
  hotline: "",
  companyStartTime: new Date(),
  companyEndTime: new Date(),
  companyWebsite: "",
  companyImageFile: "",
  companyLogoFile: "",
  companyImage: "",
  companyLogo: "",

  namePay: "",
  numberPay: "",
  bankPay: "",
  qrPayFile: "",
  qrPayImage: "",

  companyMenuHash: "",
  domain: "",
  links: [],
  valueNewLink: "",
  dynamic_form: [],
};

class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      show: {
        update: false,
        update_company: false,
      },

      fullname: "",
      email: "",
      birthDay: new Date(),
      avatar: "",
      avatarImageFile: "",
      phone: "",

      companyName: "",
      companyUUID: "",
      companyAddress: "",
      hotline: "",
      companyStartTime: new Date(),
      companyEndTime: new Date(),
      companyWebsite: "",
      companyImageFile: "",
      companyLogoFile: "",
      companyImage: "",
      companyLogo: "",
      companyMenuHash: "",
      domain: "",
      links: [],
      valueNewLink: "",

      data_dynamic_form: [],
      // form: DEFAULT_FORM_PERSONAL,
      // form_company: DEFAULT_FORM_COMPANY,

      namePay: "",
      numberPay: "",
      bankPay: "",
      qrPayFile: "",
      qrPayImage: "",
      description: "",
      address: "",
      businessType: "",
      showTemplate: false,
      canDismissTemplate: false,
      dismissingTemplate: false,
    };
    this.socket = createSocket();

    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.handleDeleteImage = this.handleDeleteImage.bind(this);
    this.handleChangeBirthDay = this.handleChangeBirthDay.bind(this);
    this.handleChangeCompanyStartTime =
      this.handleChangeCompanyStartTime.bind(this);
    this.handleChangeCompanyEndTime =
      this.handleChangeCompanyEndTime.bind(this);
    // this.onSubmitUpdate = this.onSubmitUpdate.bind(this);
    this.onSubmitUpdatePersonal = this.onSubmitUpdatePersonal.bind(this);
    this.onSubmitUpdateCompany = this.onSubmitUpdateCompany.bind(this);
    this.onChangeValueMenuLink = this.onChangeValueMenuLink.bind(this);
    this.onCreateMenu = this.onCreateMenu.bind(this);
    this.companyLogoInput = React.createRef();
    this.companyImageInput = React.createRef();
  }

  componentWillUnmount() {
    this.socket.close();
  }

  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    this.dataRender();
    // this.onLoadMenuLinks();
  }

  dataRender() {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/user"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        // console.log('data: ', data);
        this.setState({
          fullname: data.data.fullname || "",
          email: data.data.email || "",
          companyAddress: data.data.companyAddress || "",
          hotline: data.data.hotline || "",
          companyUUID: data.data.companyUUID || "",
          companyName: data.data.companyName || "",
          companyWebsite: data.data.companyWebsite || "",
          birthDay: data.data.birthDate || new Date(),
          phone: data.data.phoneNumber || "",
          avatar: data.data.image || "",
          companyStartTime: data.data.companyStartTime || new Date(),
          companyEndTime: data.data.companyEndTime || new Date(),
          companyImage: data.data.companyImage || "",
          companyLogo: data.data.companyLogo || "",
          companyMenuHash: data.data.companyMenuHash || "",
          domain: data.data.domain || "",
          isLoading: true,

          namePay: data.data.namePay || "",
          numberPay: data.data.numberPay || "",
          bankPay: data.data.bankPay || "",
          qrPayImage: data.data.qrPayImage || "",
          description: data.data.description || "",
          address: data.data.address || "",
          businessType: data.data.businessType || "",
          showTemplate: Boolean(data.data.showTemplate),
          canDismissTemplate:
            Number(data.data.id) === Number(data.data.idParent) ||
            Boolean(data.data.admin),
        });

        localStorage.setItem("fullname", data.data.fullname);
        localStorage.setItem("companyAddress", data.data.companyAddress);
        localStorage.setItem("hotline", data.data.hotline);
        localStorage.setItem("companyWebsite", data.data.companyWebsite);
        localStorage.setItem("companyName", data.data.companyName);
        localStorage.setItem("companyImage", data.data.companyImage);
        localStorage.setItem("companyLogo", data.data.companyLogo);
        localStorage.setItem("avatar", data.data.image);
        localStorage.setItem(
          "vmass_store_domain",
          data.data.domain || localStorage.getItem("vmass_store_domain") || "",
        );

        localStorage.setItem("namePay", data.data.namePay);
        localStorage.setItem("numberPay", data.data.numberPay);
        localStorage.setItem("bankPay", data.data.bankPay);
        localStorage.setItem("qrPayImage", data.data.qrPayImage);
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText);
      });
  }

  handleChangeValue(e, _name) {
    if (!isF(ROLE_ALIAS)) return false;

    if (!e) return false;

    if (e.target) {
      // input
      const { name, value } = e.target;

      this.setState((prevState) => ({ ...prevState, [name]: value }));

      if (name === "avatar") {
        this.setState({ avatarImageFile: e.target.files[0] });
      }

      if (name === "companyImage") {
        this.setState({ companyImageFile: e.target.files[0] });
      }

      if (name === "companyLogo") {
        this.setState({ companyLogoFile: e.target.files[0] });
      }

      if (name === "qrPayImage") {
        this.setState({ qrPayFile: e.target.files[0] });
      }
    } else {
      let value = e;
      if (_name === "bankPay") {
        value = e.value;
        // console.log('value: ', value);
      }
      this.setState((prev) => ({
        ...prev,
        [_name]: value,
      }));
    }
  }

  handleDeleteImage(type) {
    if (!isF(ROLE_ALIAS)) return false;

    this.setState({
      [type]: "",
    });
  }

  handleChangeBirthDay(date) {
    if (!isF(ROLE_ALIAS)) return false;

    this.setState({ birthDay: date });
  }

  handleChangeCompanyStartTime(time) {
    if (!isF(ROLE_ALIAS)) return false;

    this.setState({ companyStartTime: time });
  }

  handleChangeCompanyEndTime(time) {
    if (!isF(ROLE_ALIAS)) return false;

    this.setState({ companyEndTime: time });
  }

  handleImageChangeAndPreview = (e) => {
    let file = e.target.files[0];
    if (file) {
      let previewUrl = URL.createObjectURL(file);
      this.setState({
        avatarImageFile: file,
        avatar: previewUrl,
        companyLogoFile: file,
        companyLogo: previewUrl,
      });
    }
  };

  handleCoverImageChange = (e) => {
    let file = e.target.files[0];
    if (file) {
      let previewUrl = URL.createObjectURL(file);
      this.setState({
        companyImageFile: file,
        companyImage: previewUrl,
      });
    }
  };

  // async onSubmitUpdate() {
  //     if (!isF(ROLE_ALIAS)) return false;

  //     if (this.state.companyName === '' || this.state.companyAddress === '') {
  //         NotificatioErrController(
  //             'Tên cửa hàng và địa chỉ không được trống. Vui lòng cập nhật để sử dụng hóa đơn.'
  //         );
  //         return false;
  //     }

  //     let birthDate = moment(this.state.birthDay).format('YYYY-MM-DD');
  //     let companyStartTime = moment(
  //         this.state.companyStartTime,
  //         'HH:mm'
  //     ).format('HH:mm');
  //     let companyEndTime = moment(this.state.companyEndTime, 'HH:mm').format(
  //         'HH:mm'
  //     );

  //     let formData = new FormData();
  //     if (this.state.avatar) {
  //         formData.append('avatar', this.state.avatarImageFile);
  //     }

  //     if (this.state.companyImage) {
  //         formData.append('companyImage', this.state.companyImageFile);
  //     }

  //     if (this.state.companyLogo) {
  //         formData.append('companyLogo', this.state.companyLogoFile);
  //     }

  //     formData.append('fullname', this.state.fullname);
  //     formData.append('email', this.state.email);
  //     formData.append('companyName', this.state.companyName);
  //     formData.append('companyAddress', this.state.companyAddress);
  //     formData.append('companyWebsite', this.state.companyWebsite.trim());
  //     formData.append('phoneNumber', this.state.phone);
  //     formData.append('birthDate', birthDate);
  //     formData.append('companyStartTime', companyStartTime);
  //     formData.append('companyEndTime', companyEndTime);

  //     this.setState({ isLoading: false });

  //     // axios submit
  //     let tokenStr = localStorage.getItem('access_token');
  //     axios
  //         .put(`${END_POINT + '/user'}`, formData, {
  //             headers: {
  //                 Authorization: `Bearer ${tokenStr}`,
  //                 'content-type': 'multipart/form-data',
  //             },
  //         })
  //         .then((res) => {
  //             return res.data;
  //         })
  //         .then((data) => {
  //             NotificatioSucController(data.responseText);

  //             this.socket.emit('create logs', {
  //                 user_id: localStorage.getItem('user_id'),
  //                 message: LogsHelper['profile-update'],
  //             });

  //             this.setState({
  //                 avatarImageFile: '',
  //                 companyImageFile: '',
  //                 companyLogoFile: '',
  //                 isLoading: true,
  //             });

  //             this.dataRender();
  //         })
  //         .catch((err) => {
  //             NotificatioErrController(err.response.data.responseText);
  //         });
  // }

  onSubmitUpdatePersonal() {
    if (!isF(ROLE_ALIAS)) return false;

    this.setState({ isLoading: true });

    let birthDate = moment(this.state.birthDay).format("YYYY-MM-DD");
    let companyStartTime = moment(this.state.companyStartTime, "HH:mm").format(
      "HH:mm",
    );
    let companyEndTime = moment(this.state.companyEndTime, "HH:mm").format(
      "HH:mm",
    );

    let formData = new FormData();
    if (isFileObject(this.state.avatarImageFile)) {
      formData.append("avatar", this.state.avatarImageFile);
    }
    if (isFileObject(this.state.companyLogoFile)) {
      formData.append("companyLogo", this.state.companyLogoFile);
    }
    if (isFileObject(this.state.companyImageFile)) {
      formData.append("companyImage", this.state.companyImageFile);
    }

    formData.append("fullname", this.state.fullname);
    formData.append("phoneNumber", this.state.phone);
    formData.append("email", this.state.email);
    formData.append("address", this.state.address);
    formData.append("birthDate", birthDate);
    formData.append("description", this.state.description);

    formData.append("companyName", this.state.companyName);
    formData.append("companyAddress", this.state.companyAddress);
    formData.append("hotline", this.state.hotline);
    formData.append("companyWebsite", this.state.companyWebsite.trim());
    formData.append("companyStartTime", companyStartTime);
    formData.append("companyEndTime", companyEndTime);
    formData.append("namePay", this.state.namePay);
    formData.append("numberPay", this.state.numberPay);
    formData.append("bankPay", this.state.bankPay);

    // axios submit
    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(`${END_POINT + "/user"}`, formData, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        NotificatioSucController(data.responseText);

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["profile-update"],
        });

        this.setState({
          avatarImageFile: "",
          companyLogoFile: "",
          companyImageFile: "",
          // isLoading: false,
        });

        this.dataRender();
        // this.toggle('update');
      })
      .catch((err) => {
        // --- FIX 3: Xử lý lỗi tốt hơn ---
        const { intl } = this.props;
        let message = intl.formatMessage({ id: "profile.error" });
        if (
          err.response &&
          err.response.data &&
          err.response.data.responseText
        ) {
          message = err.response.data.responseText;
        } else if (err.message) {
          message = err.message; // Bắt các lỗi mạng, timeout...
        }
        NotificatioErrController(message);
        console.error("Lỗi khi cập nhật profile:", err.response || err);
      })
      .finally(() => {
        // --- FIX 1 (tiếp): Luôn tắt isLoading khi request hoàn thành (dù thành công hay thất bại) ---
        this.setState({ isLoading: false });
      });
  }

  onSubmitUpdateCompany() {
    if (!isF(ROLE_ALIAS)) return false;

    this.setState({ isLoading: true });
    let birthDate = moment(this.state.birthDay).format("YYYY-MM-DD");

    // if (this.state.companyName === '') {
    //     NotificatioErrController(
    //         'Tên cửa hàng không được để trống. Vui lòng cập nhật để sử dụng hóa đơn.'
    //     );
    //     return false;
    // }

    // if (this.state.companyAddress === '') {
    //     NotificatioErrController(
    //         'Địa chỉ cửa hàng không được để trống. Vui lòng cập nhật để sử dụng hóa đơn.'
    //     );
    //     return false;
    // }

    let companyStartTime = moment(this.state.companyStartTime, "HH:mm").format(
      "HH:mm",
    );
    let companyEndTime = moment(this.state.companyEndTime, "HH:mm").format(
      "HH:mm",
    );

    let formData = new FormData();

    if (isFileObject(this.state.avatarImageFile)) {
      formData.append("avatar", this.state.avatarImageFile);
    }

    if (isFileObject(this.state.companyImageFile)) {
      formData.append("companyImage", this.state.companyImageFile);
    }

    if (isFileObject(this.state.companyLogoFile)) {
      formData.append("companyLogo", this.state.companyLogoFile);
    }

    if (isFileObject(this.state.qrPayFile)) {
      formData.append("qrPayImage", this.state.qrPayFile);
    }

    formData.append("fullname", this.state.fullname);
    formData.append("phoneNumber", this.state.phone);
    formData.append("email", this.state.email);
    formData.append("address", this.state.address);
    formData.append("birthDate", birthDate);
    formData.append("description", this.state.description);

    formData.append("companyName", this.state.companyName);
    formData.append("companyAddress", this.state.companyAddress);
    formData.append("hotline", this.state.hotline);
    formData.append("companyWebsite", this.state.companyWebsite);
    formData.append("companyStartTime", companyStartTime);
    formData.append("companyEndTime", companyEndTime);

    formData.append("namePay", this.state.namePay);
    formData.append("numberPay", this.state.numberPay);
    formData.append("bankPay", this.state.bankPay);

    // console.log('fullname: ', this.state.fullname)
    // console.log('phoneNumber: ', this.state.phone)
    // console.log('email: ', this.state.email)
    // console.log('address: ', this.state.address)
    // console.log('companyName: ', this.state.companyName)
    // console.log('companyAddress: ', this.state.companyAddress)
    // console.log('hotline: ', this.state.hotline)

    // axios submit
    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(`${END_POINT + "/user"}`, formData, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        NotificatioSucController(data.responseText);

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["profile-company-update"],
        });

        this.setState({
          companyImageFile: "",
          companyLogoFile: "",
          qrPayFile: "",
          isLoading: false,
        });

        this.dataRender();
        // this.toggle('update_company');
      })
      .catch((err) => {
        const { intl } = this.props;
        const errorMessage =
          err.response?.data?.responseText ||
          intl.formatMessage({ id: "profile.error" });
        NotificatioErrController(errorMessage);
        this.setState({ isLoading: false });
      });
  }

  onChangeValueMenuLink(e) {
    if (!isF(ROLE_ALIAS)) return false;

    if (!e) return false;

    if (!e.target) return false;

    const { value } = e.target;

    this.setState({ valueNewLink: value });
  }

  onCreateMenu(e) {
    e.preventDefault();

    if (this.state.valueNewLink === "") return false;

    let tokenStr = localStorage.getItem("access_token");
    return axios
      .post(
        `${END_POINT + "/user-link"}`,
        {
          identify: this.state.valueNewLink.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
          },
        },
      )
      .then(() => {
        this.onLoadMenuLinks();
      })
      .catch((err) => {
        const { intl } = this.props;
        const errorMessage =
          err.response?.data?.responseText ||
          intl.formatMessage({ id: "profile.error" });
        NotificatioErrController(errorMessage);
      });
  }

  onLoadMenuLinks() {
    let tokenStr = localStorage.getItem("access_token");

    return axios
      .get(
        // `${END_POINT + "/user-link"}`,
        `${END_POINT + "/table/all_identify"}`,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
          },
        },
      )
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        this.setState({ links: data.data, valueNewLink: "" });
      })
      .catch((err) => {
        const { intl } = this.props;
        const errorMessage =
          err.response?.data?.responseText ||
          intl.formatMessage({ id: "profile.error" });
        NotificatioErrController(errorMessage);
      });
  }

  onClickDeleteMenuLink(id) {
    if (!id || id < 0) return false;

    let tokenStr = localStorage.getItem("access_token");
    return axios
      .delete(`${END_POINT + "/user-link"}`, {
        data: {
          id: id,
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        NotificatioSucController("Thành công");
        this.onLoadMenuLinks();
      })
      .catch((err) => {
        const { intl } = this.props;
        const errorMessage =
          err.response?.data?.responseText ||
          intl.formatMessage({ id: "profile.error" });
        NotificatioErrController(errorMessage);
      });
  }

  renderLinks = (links) => {
    return links.map((link) => (
      <li key={link.id}>
        <Badge color="danger">{link.u}</Badge>
        <i
          id={"Tooltip-" + link.id + "-copy"}
          className="iconsminds-file-copy"
          onClick={() => {
            copyToClipboard(buildPublicMenuUrl(link.u, this.state.domain));
          }}
        />

        <CustomTooltip
          placement="top"
          id={link.id + "-copy"}
          body={"Sao chép"}
        />
      </li>
    ));
  };
  renderListLinks = () => {
    return this.state.links.length ? (
      <ul className="profile-company-menu-link">
        {this.renderLinks(this.state.links)}
      </ul>
    ) : (
      <></>
    );
  };

  // onHandlerUpdate = () => {
  //     if (!isU(ROLE_ALIAS)) return false;

  //     const { id, name, phone, email, address, dynamic_form } =
  //         this.state.form;

  //     if (!name || !id) {
  //         NotificatioErrController('Dữ liệu không hợp lệ');
  //         return;
  //     }

  //     let tokenStr = localStorage.getItem('access_token');
  //     axios
  //         .put(
  //             `${END_POINT + '/company-provider'}`,
  //             {
  //                 id,
  //                 name,
  //                 phone,
  //                 email,
  //                 address,
  //                 dynamic_form,
  //             },
  //             {
  //                 headers: { Authorization: `Bearer ${tokenStr}` },
  //             }
  //         )
  //         .then((res) => res.data)
  //         .then((data) => {
  //             NotificatioSucController('Thành công');

  //             this.socket.emit('create logs', {
  //                 user_id: localStorage.getItem('user_id'),
  //                 message: LogsHelper['company-provider-update'],
  //             });

  //             this.dataListRender();
  //             this.toggle('update');
  //         })
  //         .catch((err) => {
  //             NotificatioErrController(err.response.data.responseText);
  //             return false;
  //         });
  // };

  toggle = (name) => {
    if (name === "add" && !isC(ROLE_ALIAS)) return false;
    if (name === "update" && !isU(ROLE_ALIAS)) return false;
    if (name === "update_company" && !isU(ROLE_ALIAS)) return false;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: name === "update_company" ? false : prev.show.update,
        update_company: name === "update" ? false : prev.show.update_company,
        [name]: !prev.show[name],
      },
      // selectedItems: name === 'add' ? [] : prev.selectedItems,
      form: name === "update" ? prev.form : DEFAULT_FORM_PERSONAL,
      form:
        name === "update_company" ? prev.form_company : DEFAULT_FORM_COMPANY,
    }));
  };

  toggleTemplateVisibility = async (show) => {
    const { intl } = this.props;
    const confirmMsg = intl.formatMessage({
      id: show ? "template.profile.show-confirm" : "template.profile.confirm",
    });
    if (!window.confirm(confirmMsg)) {
      return;
    }

    this.setState({ dismissingTemplate: true });
    try {
      const tokenStr = localStorage.getItem("access_token");
      await axios.put(
        `${END_POINT}/user/template-visibility`,
        { showTemplate: show },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );
      this.setState({ showTemplate: show, dismissingTemplate: false });
      NotificatioSucController(
        intl.formatMessage({
          id: show ? "template.profile.show-success" : "template.profile.success",
        }),
      );
    } catch (err) {
      this.setState({ dismissingTemplate: false });
      NotificatioErrController(
        err.response?.data?.responseText ||
          intl.formatMessage({ id: "profile.error" }),
      );
    }
  };

  render() {
    let {
      fullname,
      email,
      phone,
      birthDay,
      companyAddress,
      hotline,
      companyName,
      companyWebsite,
      companyUUID,
      avatar,
      avatarImageFile,
      companyStartTime,
      companyEndTime,
      companyMenuHash,
      domain,
      companyImage,
      companyImageFile,
      companyLogo,
      companyLogoFile,
      isLoading,
      // form,
      // form_company,
      show,
      // data_dynamic_form,

      namePay,
      numberPay,
      bankPay,
      qrPayFile,
      qrPayImage,
      description,
      address,
      businessType,
      showTemplate,
      canDismissTemplate,
      dismissingTemplate,
    } = this.state;

    // console.log('fullname: ', fullname);
    // console.log('phone: ', phone);
    // console.log('address: ', companyAddress);
    // console.log('namePay: ', namePay);
    // console.log('numberPay: ', numberPay);
    // console.log('bankPay: ', bankPay);

    const shopDefault = "VMASS";
    const menuOnlineUrl = buildPublicMenuUrl(companyMenuHash, domain);

    return !isLoading ? (
      <div className="loading" />
    ) : (
      <React.Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.profile" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card>
              <input
                type="file"
                className="d-none"
                ref={this.companyImageInput}
                onChange={this.handleCoverImageChange}
                accept="image/*"
              />
              <div
                className="position-absolute cursor-pointer bg-white d-flex justify-content-center align-items-center"
                style={{
                  right: "20px",
                  top: "20px",
                  zIndex: 10,
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                }}
                onClick={() => this.companyImageInput.current.click()}
              >
                <i className="simple-icon-pencil text-primary font-weight-bold" />
              </div>
              <SingleLightbox
                thumb={getCompanyImage({ companyImage })}
                large={getCompanyImage({ companyImage })}
                className="social-header card-img"
                fallback={DEFAULT_COVER}
              />
            </Card>
          </Colxx>
          <Colxx xxs="12" lg="4" className="col-left">
            <input
              type="file"
              className="d-none"
              ref={this.companyLogoInput}
              onChange={this.handleImageChangeAndPreview}
              accept="image/*"
            />
            <div className="position-relative d-inline-block social-profile-img">
              <div
                className="position-absolute cursor-pointer bg-white d-flex justify-content-center align-items-center"
                style={{
                  right: "0px",
                  top: "0px",
                  zIndex: 10,
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                }}
                onClick={() => this.companyLogoInput.current.click()}
              >
                <i className="simple-icon-pencil text-primary font-weight-bold" />
              </div>
              <SingleLightbox
                thumb={getAvatar(companyLogo)}
                large={getAvatar(companyLogo)}
                className="card-img"
              />
            </div>
            <Card className="mb-4">
              <CardBody>
                <div className="pt-4 mb-3">
                  <p className="text-muted text-small mb-2">
                    <IntlMessages id="profile.fullname" />
                  </p>
                  <Input
                    className="custom-input-underline text-capitalize"
                    type="text"
                    name="fullname"
                    id="fullname"
                    value={fullname}
                    onChange={this.handleChangeValue}
                    placeholder={this.props.intl.formatMessage({
                      id: "profile.placeholder.fullname",
                    })}
                  />
                </div>

                <div className="mb-3">
                  <p className="text-muted text-small mb-2">
                    <IntlMessages id="profile.description" />
                  </p>
                  <Input
                    className="custom-input-underline"
                    type="text-area"
                    name="description"
                    id="description"
                    placeholder={this.props.intl.formatMessage({
                      id: "profile.placeholder.description",
                    })}
                    value={description}
                    onChange={this.handleChangeValue}
                  />
                </div>

                <div className="mb-3">
                  <p className="text-muted text-small mb-2">
                    <IntlMessages id="profile.address" />
                  </p>
                  <Input
                    className="custom-input-underline"
                    type="text"
                    name="address"
                    id="address"
                    placeholder={this.props.intl.formatMessage({
                      id: "profile.placeholder.address",
                    })}
                    value={address}
                    onChange={this.handleChangeValue}
                  />
                </div>

                <div className="mb-3">
                  <p className="text-muted text-small mb-2">
                    <IntlMessages id="profile.phone" />
                  </p>
                  <Input
                    className="custom-input-underline"
                    type="text"
                    name="phone"
                    id="phone"
                    placeholder={this.props.intl.formatMessage({
                      id: "profile.placeholder.phone",
                    })}
                    value={phone}
                    onChange={this.handleChangeValue}
                  />
                </div>

                <div className="mb-3">
                  <p className="text-muted text-small mb-2">
                    <IntlMessages id="profile.email" />
                  </p>
                  <Input
                    className="custom-input-underline text-lowercase"
                    type="text"
                    name="email"
                    id="email"
                    placeholder={this.props.intl.formatMessage({
                      id: "profile.placeholder.email",
                    })}
                    value={email}
                    onChange={this.handleChangeValue}
                  />
                </div>
                <div className="d-flex justify-content-center mt-4">
                  <Button color="primary" onClick={this.onSubmitUpdatePersonal}>
                    <IntlMessages id="profile.update-personal" />
                  </Button>
                </div>
              </CardBody>
            </Card>
            {canDismissTemplate ? (
              <Card className="mb-4 border-info">
                <CardBody>
                  <h5 className="mb-2">
                    <IntlMessages id="template.profile.title" />
                  </h5>
                  <p className="text-muted mb-3">
                    <IntlMessages id="template.profile.description" />
                  </p>
                  {showTemplate ? (
                    <Button
                      color="danger"
                      outline
                      block
                      disabled={dismissingTemplate}
                      onClick={() => this.toggleTemplateVisibility(false)}
                    >
                      {dismissingTemplate ? (
                        <span className="spinner-border spinner-border-sm mr-2" />
                      ) : null}
                      <IntlMessages id="template.profile.dismiss" />
                    </Button>
                  ) : (
                    <Button
                      color="success"
                      outline
                      block
                      disabled={dismissingTemplate}
                      onClick={() => this.toggleTemplateVisibility(true)}
                    >
                      {dismissingTemplate ? (
                        <span className="spinner-border spinner-border-sm mr-2" />
                      ) : null}
                      <IntlMessages id="template.profile.show" />
                    </Button>
                  )}
                </CardBody>
              </Card>
            ) : null}
          </Colxx>
          <Colxx xxs="12" lg="8" className="mb-4 col-right">
            <Card>
              {/* <div
                                className='position-absolute card-avatar-buttons cursor-pointer'
                                onClick={() => this.toggle('update_company')}
                            >
                                <i className='simple-icon-note' />
                            </div> */}
              <CardBody>
                {companyAddress === "" ||
                hotline === "" ||
                namePay === "" ||
                numberPay === "" ||
                bankPay === "" ? (
                  <Card color="warning" className="mb-4 text-center">
                    <CardBody className="p-3">
                      <IntlMessages id="profile.validate.required" />
                    </CardBody>
                  </Card>
                ) : null}
                <Row className="d-flex justify-content-center">
                  <h2 className="mb-3">
                    <Input
                      className="custom-input-underline text-center fw-bold"
                      style={{ fontSize: "2rem" }}
                      type="text"
                      name="companyName"
                      id="company-name"
                      placeholder={shopDefault}
                      value={companyName}
                      onChange={this.handleChangeValue}
                    />
                  </h2>
                </Row>
                <Row className="mt-3 ">
                  <Colxx xxs="12" lg="5" className="mb-4">
                    <p className="text-muted text-small mb-2">
                      <IntlMessages id="company-uuid" />
                    </p>
                    <p className="mb-3">{companyUUID}</p>
                  </Colxx>
                  <Colxx xxs="12" lg="4" className="mb-4">
                    <p className="text-muted text-small mb-2">
                      <IntlMessages id="profile.business-type.label" />
                    </p>
                    <Badge
                      color={
                        businessType === "cafe"
                          ? "warning"
                          : businessType === "restaurant"
                            ? "danger"
                            : businessType === "retail"
                              ? "success"
                              : businessType === "fashion"
                                ? "info"
                                : businessType === "cosmetics"
                                  ? "primary"
                                  : "secondary"
                      }
                      className="mb-1"
                    >
                      {businessType === "cafe" ? (
                        <IntlMessages id="profile.business-type.cafe" />
                      ) : businessType === "restaurant" ? (
                        <IntlMessages id="profile.business-type.restaurant" />
                      ) : businessType === "retail" ? (
                        <IntlMessages id="profile.business-type.retail" />
                      ) : businessType === "fashion" ? (
                        <IntlMessages id="profile.business-type.fashion" />
                      ) : businessType === "cosmetics" ? (
                        <IntlMessages id="profile.business-type.cosmetics" />
                      ) : (
                        <IntlMessages id="profile.business-type.unknown" />
                      )}
                    </Badge>
                  </Colxx>
                  <Colxx xxs="12" lg="7" className="mb-4">
                    <p className="text-muted text-small mb-2">
                      <IntlMessages id="profile.company-menu-hash" />
                    </p>
                    <div className="mb-3">
                      <p
                        className="mb-2 break-word"
                        style={{ wordBreak: "break-all" }}
                      >
                        {menuOnlineUrl || "--"}
                      </p>
                      <div className="d-flex align-items-center">
                        <Button
                          color="outline-primary"
                          size="sm"
                          onClick={() => copyToClipboard(menuOnlineUrl)}
                          disabled={!menuOnlineUrl}
                        >
                          Sao chép link
                        </Button>
                      </div>
                    </div>
                    <div>
                      <MenuOnlineQrCard
                        menuUrl={menuOnlineUrl}
                        companyName={companyName}
                        companyAddress={companyAddress}
                        hotline={hotline}
                        previewWidth={125}
                      />
                    </div>
                  </Colxx>
                </Row>
                <Row>
                  <Colxx xxs="12" lg="5" className="mb-4">
                    <p className="text-muted text-small mb-2">
                      <IntlMessages id="profile.company-website" />
                    </p>
                    <Input
                      className="custom-input-underline text-lowercase"
                      type="text"
                      name="companyWebsite"
                      id="company-website"
                      placeholder={this.props.intl.formatMessage({
                        id: "profile.placeholder.website",
                      })}
                      value={companyWebsite}
                      onChange={this.handleChangeValue}
                    />
                  </Colxx>
                  <Colxx xxs="12" lg="7" className="mb-4">
                    <p className="text-muted text-small mb-2">
                      Hotline
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        *
                      </span>
                    </p>
                    <Input
                      className="custom-input-underline"
                      type="phone"
                      name="hotline"
                      id="hotline"
                      placeholder={this.props.intl.formatMessage({
                        id: "profile.placeholder.hotline",
                      })}
                      value={hotline}
                      onChange={this.handleChangeValue}
                    />
                  </Colxx>
                </Row>
                <Row>
                  <Colxx xxs="12" lg="7" className="mb-4">
                    <p className="text-muted text-small mb-2">
                      <IntlMessages id="profile.company-address" />
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        *
                      </span>
                    </p>
                    <Input
                      className="custom-input-underline"
                      type="text"
                      name="companyAddress"
                      id="company-address"
                      placeholder={this.props.intl.formatMessage({
                        id: "profile.placeholder.address",
                      })}
                      value={companyAddress}
                      onChange={this.handleChangeValue}
                    />
                  </Colxx>
                </Row>
                <Row>
                  <Colxx xxs="12" lg="6" className="mb-4">
                    <p className="text-muted text-small mb-2">
                      <IntlMessages id="profile.company-start-time" />
                    </p>
                    <DatePicker
                      name="companyStartTime"
                      id="company-start-time"
                      className="mb-3"
                      onChange={(time) =>
                        this.handleChangeCompanyStartTime(time)
                      }
                      selected={moment(companyStartTime, "HH:mm")}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={5}
                      timeCaption="Giờ"
                      timeFormat="HH:mm"
                      dateFormat="HH:mm"
                    />
                  </Colxx>
                  <Colxx xxs="12" lg="6" className="mb-4">
                    <p className="text-muted text-small mb-2">
                      <IntlMessages id="profile.company-end-time" />
                    </p>
                    <DatePicker
                      name="companyEndTime"
                      id="company-end-time"
                      className="mb-3"
                      onChange={(time) => this.handleChangeCompanyEndTime(time)}
                      selected={moment(companyEndTime, "HH:mm")}
                      showTimeSelectOnly
                      showTimeSelect
                      timeIntervals={5}
                      timeCaption="Giờ"
                      timeFormat="HH:mm"
                      dateFormat="HH:mm"
                    />
                  </Colxx>
                </Row>
                <Separator />

                <Row>
                  <Colxx
                    lg="3"
                    className="text-uppercase fs-1 fw-bold mt-4 text-right d-flex justify-content-center align-items-center"
                  >
                    <h3>
                      <IntlMessages id="profile.payment-info.title" />
                    </h3>
                  </Colxx>
                  <Colxx
                    lg="3"
                    className="d-flex justify-content-center align-items-center mt-4"
                  >
                    {bankPay && numberPay ? (
                      // <SingleLightbox
                      //     thumb={getAvatar(qrPayImage)}
                      //     large={getAvatar(qrPayImage)}
                      //     className='img-thumbnail card-img qrpay'
                      // />
                      <SingleLightbox
                        thumb={getQrPay(bankPay, numberPay)}
                        large={getQrPay(bankPay, numberPay)}
                        className="img-thumbnail card-img qrpay"
                      />
                    ) : null}
                  </Colxx>
                  <Colxx
                    lg="6"
                    className="mt-4 text-left d-flex flex-column justify-content-center px-3"
                  >
                    <Row className="d-flex align-items-center mb-3 px-2">
                      <p className="mb-1 text-muted text-small pr-2">
                        <IntlMessages id="profile.bankPay" />
                        <span
                          style={{
                            color: "red",
                          }}
                        >
                          *
                        </span>
                        :
                      </p>
                      <div className="w-100">
                        <Select
                          defaultValue={GetBank(bankPay)}
                          components={{ Input: CustomSelectInput }}
                          className="react-select"
                          classNamePrefix="react-select"
                          name="bankPay"
                          placeholder={this.props.intl.formatMessage({
                            id: "profile.placeholder.bank",
                          })}
                          options={SetBank}
                          onChange={(e) => this.handleChangeValue(e, "bankPay")}
                          menuPlacement="top"
                          // value={GetBank(bankPay)}
                        />
                      </div>
                    </Row>
                    <Row className="d-flex align-items-center mb-3 px-2">
                      <p className="mb-1 text-muted text-small pr-2">
                        <IntlMessages id="profile.namePay" />
                        <span
                          style={{
                            color: "red",
                          }}
                        >
                          *
                        </span>
                        :
                      </p>
                      <Input
                        className="custom-input-underline"
                        type="text"
                        name="namePay"
                        id="name-pay"
                        placeholder={this.props.intl.formatMessage({
                          id: "profile.placeholder.account-name",
                        })}
                        value={namePay}
                        onChange={this.handleChangeValue}
                      />
                    </Row>
                    <Row className="d-flex align-items-center mb-3 px-2">
                      <p className="mb-1 text-muted text-small pr-2">
                        <IntlMessages id="profile.numberPay" />
                        <span
                          style={{
                            color: "red",
                          }}
                        >
                          *
                        </span>
                        :
                      </p>
                      <Input
                        className="custom-input-underline"
                        type="text"
                        name="numberPay"
                        id="number-pay"
                        placeholder={this.props.intl.formatMessage({
                          id: "profile.placeholder.account-number",
                        })}
                        value={numberPay}
                        onChange={this.handleChangeValue}
                      />
                    </Row>
                  </Colxx>
                </Row>
                <div className="d-flex justify-content-center mt-4">
                  <Button color="primary" onClick={this.onSubmitUpdateCompany}>
                    <IntlMessages id="profile.update-company" />
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </React.Fragment>
    );
  }
}

export default injectIntl(Profile);
